class OnboardingUsersQuestionniareCtrl {
  constructor() {
    'ngInject';
  }
}

export default OnboardingUsersQuestionniareCtrl;
